// eslint-disable-next-line import/no-unresolved
import { SplitFactory } from '@splitsoftware/splitio';
import config from './config';

const factory = SplitFactory({
  core: {
    key: 'anonymous',
    authorizationKey: config.splitio.apiKey,
  },
  startup: {
    readyTimeout: 1.5, // in seconds
  },
});

export default factory;



// WEBPACK FOOTER //
// ./src/splitio.js